import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { HostResponseCodeEntity } from "../../types/HostResponseCodeEntity";
import { HostResponseCodeDtoToEntity } from "../mappers/HostResponseCodeDtoToEntity";
import { HostResponseCodeEntityToDto } from "../mappers/HostResponseCodeEntityToDto";

const HostResponseCodeApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        HostResponseCodeLoad: builder.query<HostResponseCodeEntity, FormQuery>({
            providesTags: [ResourceName.HOST_RESPONSE_CODE],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_RESPONSE_CODE}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return HostResponseCodeDtoToEntity(response);
            },
        }),
        HostResponseCodeSave: builder.mutation<HostResponseCodeEntity, FormMutation<HostResponseCodeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_RESPONSE_CODE}`;
                const method = "POST";

                const body = HostResponseCodeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.HOST_RESPONSE_CODE],
        }),
        HostResponseCodeUpdate: builder.mutation<HostResponseCodeEntity, FormMutation<HostResponseCodeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_RESPONSE_CODE}/${mutation.data.id}`;
                const method = "PUT";

                const body = HostResponseCodeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.HOST_RESPONSE_CODE],
        }),
    }),
});

export const { useHostResponseCodeLoadQuery, useHostResponseCodeSaveMutation, useHostResponseCodeUpdateMutation } = HostResponseCodeApi;
